import {TUsedIn} from 'modules/price-n-bonuses/types';

export const USED_IN: Record<
    | 'CART_POPUP'
    | 'CART_RESUME'
    | 'MAIN_HEADER'
    | 'MAIN_OFFER'
    | 'PRODUCT_SET'
    | 'SEARCH_PANEL'
    | 'VISUAL_PREVIEW'
    | 'TECH_PREVIEW'
    | 'TECH_LIST_PREVIEW',
    TUsedIn
> = {
    CART_POPUP: 'cartPopup',
    CART_RESUME: 'cartResume',
    MAIN_HEADER: 'mainHeader',
    MAIN_OFFER: 'mainOffer',
    PRODUCT_SET: 'productSet',
    SEARCH_PANEL: 'searchPanel',
    TECH_LIST_PREVIEW: 'techListPreview',
    TECH_PREVIEW: 'techPreview',
    VISUAL_PREVIEW: 'visualPreview',
};
